import React, { FC } from 'react'
import styles from './HeaderActions.module.scss'
import { HeaderActionsProps } from './HeaderActions.model'

export const HeaderActions: FC<HeaderActionsProps> = ({ children }) => (
  <div className={styles.infoAction}>{children}</div>
)
